import { BillingPanel } from './BillingPanel';
import { AppearancePanel } from './AppearancePanel';

// Settings: low-frequency configuration. Subscription pricing (Stripe) and the
// brand accent colour.

function cls(on: boolean) {
  return on ? 'admin__subpanel' : 'admin__subpanel admin__panel--hidden';
}

export function SettingsSection({ tab }: { tab: string }) {
  return (
    <>
      <div className={cls(tab === 'pricing')}>
        <BillingPanel active={tab === 'pricing'} />
      </div>
      <div className={cls(tab === 'appearance')}>
        <AppearancePanel active={tab === 'appearance'} />
      </div>
    </>
  );
}
